<!-- <div style="max-width: 90rem"> -->
<ng-container *ngIf="!!get">
    <tt-card [hidden]="products.length <= 1 && +products[0].quantity <= 1" class="col-xs-12 p-5 sp-0" [ttHeading]="get.heading_selected_products" ttTranslateHeading="false" ttAccordion>
        <tt-list [ttData]="products" ttBadge="quantity" ttGoto="false"></tt-list>
    </tt-card>
    <tt-card class="col-xs-12 p-5 sp-0" [ttHeading]="get.heading_configuration" ttTranslateHeading="false" ttAccordion>
        <ng-container *ngFor="let question of questionList; trackBy: trackBy">
            <ng-container *ngIf="question.hide === '0'">
                <tt-select
                    *ngIf="question.selecttype === SelectTypes.DropDown"
                    [hidden]="question.isvisible !== '1'"
                    ttTranslateLabel="false"
                    ttTranslateSublabel="false"
                    [ttLabel]="question.choice_prod_name"
                    [ttSublabel]="question.sublabel"
                    [(ttModel)]="question.chosen_prod_id"
                    (ttModelChange)="onChanges($event, question)"
                    [ttData]="question.selectlistrecords"
                ></tt-select>
                <tt-search
                    *ngIf="question.selecttype === SelectTypes.Search"
                    [hidden]="question.isvisible !== '1'"
                    ttTranslateLabel="false"
                    ttTranslateSublabel="false"
                    [ttLabel]="question.choice_prod_name"
                    [ttSublabel]="question.sublabel"
                    [(ttModel)]="question.chosen_searchstring"
                    [ttSearch]="search"
                    [ttSearchParm]="{ chosen_searchstring: question.chosen_searchstring, choice_prod_id: question.choice_prod_id, restriction_prod_id: question.restriction_prod_id }"
                    (ttOnSelected)="onSearchSelected(question, $event)"
                    (ttOnClear)="onSearchSelected(question)"
                ></tt-search>
                <tt-radio-button-group
                    *ngIf="question.selecttype === SelectTypes.Radio"
                    [hidden]="question.isvisible !== '1'"
                    ttTranslateLabel="false"
                    ttTranslateSublabel="false"
                    [ttLabel]="question.choice_prod_name"
                    [ttSublabel]="question.sublabel"
                    [(ttModel)]="question.chosen_prod_id"
                    (ttModelChange)="onChanges($event, question)"
                >
                    <tt-radio-button *ngFor="let option of question.selectlistrecords" ttTranslateLabel="false" [ttLabel]="option.item_name" [ttValue]="option.item_id"></tt-radio-button>
                </tt-radio-button-group>
            </ng-container>
        </ng-container>
        <tt-button ttText="productsconfig_config" ttIcon="fas fa-sync-alt" (ttClick)="configure()" [ttLoading]="configurating"></tt-button>
    </tt-card>
    <tt-grid *ngIf="grid" class="col-xs-12 p-5 sp-0" [(ttOptions)]="grid" (ttReady)="$event === false && (configurating = false)" (ttOnRead)="onRead()"></tt-grid>
    <tt-card class="col-xs-12 p-5 sp-0">
        <tt-toast [hidden]="!saveDisabled" class="col-xs-12 sp-0 pb-7" ttType="warning" ttTitle="you_need_to_configre_the_variant_before_you_can_save"></tt-toast>
        <tt-button-save class="col-xs-12 sp-0" (ttClick)="save()" [ttLoading]="saving" [ttDisabled]="saveDisabled"></tt-button-save>
        <tt-button-settings class="col-xs-12 sp-0" *ngIf="get.show_setting === '1'"></tt-button-settings>
    </tt-card>
</ng-container>
<!-- </div> -->
